// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"aca139fb","473":"ab26e7ed","666":"c66a3dab","764":"e0d886cc","867":"f2c91dcf"}[chunkId] + ".chunk.js";
};